/*
  Unified Fields Props Definition
*/
import {FormattedMessage} from "react-intl"
import React from "react"

import moment from "moment"

export default {
	load() {
		return {
			fields: {
				from: {
					label: <FormattedMessage id="Common.label.from" />
				},
				to: {
					label: <FormattedMessage id="Common.label.to" />
				},
				identifier: {
					label: <FormattedMessage id="Patient.labels.IDNumber" />,
					rules: "string"
				},
				time_from: {
					value: moment()
						.startOf("month")
						.format("YYYY-MM-DD")
				},
				time_to: {
					value: moment()
						.endOf("month")
						.format("YYYY-MM-DD")
				},
				delivery_extension: {
					label: <FormattedMessage id="Patient.form.patientrecord.deliveryTable.deliveryExtension" />
				}
			}
		}
	}
}
